<template>
  <div class="container container--fluid">
    <v-row justify="space-between">
      <v-col cols="12" md="4">
        <PageTitle text="پروفایل کاربر" icon="mdi-home-account" />
        <v-card class="mt-4" height="85%" hover>
          <v-card-title>
            <span class="pl-3"> {{ $_t("attribute.user_type") }}: </span>
            {{ $_t(`attribute.is_admin_${user.isAdmin}`) }}
          </v-card-title>
          <v-card-title>
            <span class="pl-3"> {{ $_t("attribute.mobileNumber") }}: </span>
            {{ enToFa(user.mobileNumber) }}
          </v-card-title>
          <v-card-title>
            <span class="pl-3"> {{ $_t("attribute.register_date") }}: </span>
            {{ $_date(user.createMoment) }}
          </v-card-title>
          <v-card-title>
            <span class="pl-3"> {{ $_t("attribute.state") }}: </span>
            {{ $_t(`attribute.${user.state}`) }}
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <PageTitle text="نحوه پرداخت" icon="mdi-credit-card-outline" />
        <v-card class="mt-4" hover height="85%">
          <v-card-title class="text-break">
            لطفا هزینه ی مدرک را به شماره کارت زیر ارسال کرده و فیش پرداختی را
            از بخش داشبورد و مدرک مورد نظر ارسال کنید با تشکر
          </v-card-title>
          <v-card-title>
            {{ enToFa("6037998112962609") }}
          </v-card-title>
          <v-card-title class="text-center font-weight-bold">
            به نام علی باغبان قراملکی
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <PageTitle text="تغییر رمز عبور" icon="mdi-shield-key-outline" />
        <v-card class="mt-4" hover height="85%">
          <ResetPasswordForm />
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PageTitle from "@/packages/dashboard/components/PageTitle";
import { mapGetters } from "vuex";
import { enToFa } from "@/tools/Utils";
import ResetPasswordForm from "@/packages/dashboard/components/ResetPassword";

export default {
  name: "Profile",
  components: { ResetPasswordForm, PageTitle },
  computed: {
    ...mapGetters({
      user: "authentication/user",
    }),
  },
  methods: {
    enToFa: enToFa,
  },
};
</script>

<style scoped></style>
